import React, { FunctionComponent, useContext } from "react";
import { AppPage, LoggedOutFooter } from "../../components";
import { useTranslate } from "../../helpers/intlHooks";
import { AppStore } from "../../app/store";
import WhatMedicareCoverage from "./WhatMedicareCoverage";
import routes from "../../app/routes";
import { Redirect, withRouter, RouteComponentProps } from "react-router";

const QuestionRoutingPage: FunctionComponent<RouteComponentProps> = () => {
  const t = useTranslate();
  const { state } = useContext(AppStore.AppContext);

  if (state.beneficiary && !state.csr) {
    return <Redirect to={routes.beneLanding} />;
  }

  return (
    <AppPage heading={t("oe_questions.banner.title")}>
      <span className="sr-only">
        {t("sr_only_additional_questions_may_appear")}
      </span>
      <div className="ds-u-margin-bottom--5 PlanPreferencePage">
        <WhatMedicareCoverage />
      </div>
      <LoggedOutFooter />
    </AppPage>
  );
};

export default withRouter(QuestionRoutingPage);
